<template>
  <div class="" :class="wrapperClass" id="sidebar_checkout">
    <vehicle-details :vehicle="vehicle"
                     :subscription="subscription">
    </vehicle-details>

    <price-plans
        :vehicle-api-endpoint="apiSingleVehicle"
        :fixed-duration="hasFixedDuration"
        :given-duration="subscription.booked_month"
        :given-mileage="subscription.booked_mileage"
        @price-plan-changed="updateSubscription"
        :changeable="changeablePricePlans"
    ></price-plans>

    <partner :vehicle="vehicle"
                     :currency="currency"
                     :subscription="subscription"
                     :tolerance-limits="toleranceLimits"
                     :default-damage-participation="defaultDamageParticipation">
    </partner>
  </div>

</template>

<script>
export default {
  name: "SideBar",
  data () {
    return {
      defaultDamageParticipation: 1000,
    }
  },
  props: {
    reloadAfterChanges: {
      type: Boolean,
      required: false,
      default: false
    },
    apiSingleVehicle: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: "€"
    },
    toleranceLimits: {
      type: Array,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    durationOptions: {
      type: Array,
      required: true
    },
    mileageOptions: {
      type: Array,
      required: true
    },
    partner: {
      type: Object,
      required: false
    },
    wrapperClass: {
      type: String,
      required: false
    },
    changeablePricePlans: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    mileageChangeEnabled () {
      return false;
    },
    durationChangeEnabled () {
      return false;
    },
    currentMileage () {
      return this.mileageOptions.find (option => {
        return option.id === this.subscription.mileage_id;
      });
    },
    currentDuration () {
      return this.durationOptions.find (option => {
        return option.id === this.subscription.month_id;
      });
    },
    hasFixedDuration () {
      return this.vehicle.fixed_duration === 1
    }
  },
  methods: {
    updateSubscription (payload) {
      console.log (payload)
      axios.patch ('/api/checkout/' + this.subscription.id, {
        pricePlan: payload,
        identifier: this.subscription.identifier
      }).then (r => {
        console.log ("Abo aktualisiert:", r)
        if (this.reloadAfterChanges) {
          location.reload ()
        }
      }).catch (e => {
        console.warn ("Fehler beim Abo-Update:", e)
      })
    },
    subscriptionUpdated () {
      this.$emit ("subscription-updated");
    }
  },
  mounted () {
    axios.get ('/api/damage-participation/default').then (r => {
      this.defaultDamageParticipation = r.data.damage_participation;
    })
  }

}

</script>

<style scoped>

</style>
